export enum DniType {
  CC = 'CC',
  PASSPORT = 'PASSPORT',
  CE = 'CE',
  CPEP = 'CPEP',
  NIT = 'NIT',
}
